<fui-rows [formGroup]="editService.formGroup">
    <ng-container formGroupName="receiptConfiguration">
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-checkbox-edit-control formControlName="includeTaxesInPriceLines"
                                               [(ngModel)]="model.data.receiptConfiguration.includeTaxesInPriceLines">
                    </wbo-checkbox-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-edit-grid [data]="model.data.receiptConfiguration.taxesOnReceipt" [editable]="true"
                                   [removable]="true" [entityPath]="'receiptConfiguration.taxesOnReceipt'">
                        <wbo-edit-link-column field="tax.name" componentPath="tax"
                                              [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                        <wbo-text-column field="symbol" [editable]="true">
                        </wbo-text-column>
                        <wbo-edit-grid-add-row [identifierField]="'id'" [componentPath]="'tax'">
                            <wbo-edit-grid-add-row-quick-add>
                                <wbo-tax-single-select-edit-control>
                                </wbo-tax-single-select-edit-control>
                            </wbo-edit-grid-add-row-quick-add>
                            <wbo-edit-grid-add-row-actions>
                                <wbo-edit-grid-add-row-search
                                    [searchComponent]="TaxSearchPageComponent"></wbo-edit-grid-add-row-search>
                                <wbo-edit-grid-add-row-new-entity
                                    [editComponent]="TaxEditPageComponent"></wbo-edit-grid-add-row-new-entity>
                            </wbo-edit-grid-add-row-actions>
                        </wbo-edit-grid-add-row>
                    </wbo-edit-grid>
                </fui-column>
            </fui-two-columns>
        </fui-row>
    </ng-container>
</fui-rows>
